import React from 'react'
import LinkPill from '../../common/LinkPill'
import { useTranslation } from '../../../lib/i18n'

const EventFilters = ({ selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation()
  return (
    <div className="w-full mx-auto flex flex-row justify-start items-start gap-2 mb-4">
      <LinkPill
        active={selectedFilters.upcoming}
        onClick={() => setSelectedFilters({ upcoming: true })}
        className="px-8 max-w-min"
      >
        {t('eventFilters.upcoming')}
      </LinkPill>
      <LinkPill
        active={selectedFilters.past}
        onClick={() => setSelectedFilters({ past: true })}
        className="px-8 max-w-min"
      >
        {t('eventFilters.past')}
      </LinkPill>
    </div>
  )
}

export default EventFilters
